export const LOGIN_REQUEST = 'AUTHORIZATION/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'AUTHORIZATION/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'AUTHORIZATION/LOGIN_FAILURE';
